<script setup>
import { useI18n } from 'vue-i18n'

import AppButton from '@ui/app-button/AppButton.vue'

const { t } = useI18n()

function reload() {
  window.location.reload()
}
</script>

<template>
  <div
    class="supplier-session-error"
    role="alert"
  >
    <h1 class="supplier-session-error-title font-subsection">
      {{ t('ui.supplier_portal.session.error_title') }}
    </h1>
    <p class="supplier-session-error-text font-medium-body">
      {{ t('ui.supplier_portal.session.error_text') }}
    </p>
    <app-button
      variant="accent"
      data-element="supplier-session-retry-btn"
      @click="reload"
    >
      {{ t('ui.supplier_portal.session.retry') }}
    </app-button>
  </div>
</template>

<style lang="scss" scoped>
.supplier-session-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 24px 16px;
  gap: 16px;
  color: var(--g-neutral-3);
  text-align: center;

  &-title {
    color: var(--g-neutral-1);
  }
}
</style>
